export function initTableOfContents() {
    const tocList = document.getElementById('gh-toc-list');
    const tocNav = document.getElementById('gh-toc');
    const content = document.querySelector('.gh-post-content');
    if (!tocList || !content) return;

    // Collect h2 and h3 headings from article content
    const headings = Array.from(content.querySelectorAll('h2, h3'));
    if (headings.length < 2) {
        // Hide the TOC if there's not enough headings to justify it
        if (tocNav) tocNav.style.display = 'none';
        return;
    }

    // Ensure each heading has an id for anchor links
    headings.forEach((heading, i) => {
        if (!heading.id) {
            const slug = heading.textContent
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-|-$/g, '');
            heading.id = slug || 'heading-' + i;
        }
    });

    // Build list items
    const fragment = document.createDocumentFragment();
    headings.forEach(heading => {
        const li = document.createElement('li');
        li.className = 'gh-toc-item' + (heading.tagName === 'H3' ? ' gh-toc-item-h3' : '');

        const a = document.createElement('a');
        a.className = 'gh-toc-link';
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;

        li.appendChild(a);
        fragment.appendChild(li);
    });
    tocList.appendChild(fragment);

    // Highlight the active section using IntersectionObserver
    const links = Array.from(tocList.querySelectorAll('.gh-toc-link'));
    if (!links.length) return;

    let activeLink = links[0];
    activeLink.classList.add('is-active');

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const id = entry.target.id;
                    links.forEach(link => link.classList.remove('is-active'));
                    const current = links.find(l => l.getAttribute('href') === '#' + id);
                    if (current) {
                        current.classList.add('is-active');
                        activeLink = current;
                    }
                }
            });
        },
        {
            rootMargin: '-80px 0px -60% 0px',
            threshold: 0,
        }
    );

    headings.forEach(heading => observer.observe(heading));
}
